export const CouponAlt = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.75 18.75H2.25V14.25C3 14.25 4.5 13.5 4.5 12C4.5 10.5 3 9.75 2.25 9.75V5.25H21.75V9.75C21 9.76166 19.5 10.228 19.5 12C19.5 13.772 21 14.2383 21.75 14.25V18.75Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<circle cx="8.25" cy="9.75" r="1.25" stroke="currentColor" stroke-width="2"/>
<circle cx="15.75" cy="14.25" r="1.25" stroke="currentColor" stroke-width="2"/>
<path d="M15.75 8.25L8.20706 15.7929" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
</svg>`;
